export default __webpack_public_path__ + "static/media/VersionHistory.dc54bff8.svg";